module.exports = function(app){
    'use strict';
    app.directive('progressiveScroll', ['$q', '$timeout', '$compile','sessionData', function($q, $timeout, $compile, sessionData){
        return{
            restrict: 'A',
            scope: {
                resultList: "=",        //list to be progressively scrolled
                itemsPerPage: "=",      //how many items per page
                getMoreResults: "&?",   //optional: function to get more results. Needs to return a promise which resolves with the list to paginate
                totalResults: "=?",     //optional: total result count. Useful if service only returns a subset of total results
                tierLabels: "=?",       //optional: tier labels (used in CCE)
                showRibbon: "=?",       //optional: to show a ribbon across the right of the drawer
                eSpot: "=?",            //optional: pass in an inline e-spot image"
                eSpotClickAction: "&?", //optional: pass in a function that is called on e-spot click
                eSpotAlt: "=?"          //optional: pass in an alt tag for espot
            },
            //NOTE: not a complete template. It gets compiled with more html in the displayResults function
            template:   '<section class="progressive-scroll-list">'+
            '<div data-ng-show="showLoadingSpinner" class="loadingSpinner">'+
            '<img src="/bootstrap/v4/resources/img/loading-40.gif" />'+
            '</div>'+
            '<button data-ng-show="showMoreResultsButton()" data-ng-click="loadMoreResults()" class="primary more-results-button">More Results</button>'+
            '</section>',
            transclude: true,
            link: function(scope, element, attrs, controller, transcludeFn){
                var pageCounter = 0;   //needed to count the pages made. Shared between multiple functions

                scope.resultsDisplayed = false;
                scope.atEndOfResults = false;
                scope.resultList = scope.resultList || [];
                scope.eSpotAlt = scope.eSpotAlt || "";
                scope.showMoreClick = 0;

                //every time the result list is filtered, updated or changed, the UI will be recalculated.
                //page counter needs reset for the breaks between results too
                scope.$watchCollection("resultList", function(/*newValue, oldValue*/){
                    pageCounter = 0;
                    populateInfiniteScrollList();
                });
                scope.$watch('eSpot', function(newVal){
                    if(newVal){
                        pageCounter = 0;
                        populateInfiniteScrollList();
                    }
                });

                //attached to the moreResults button on the UI
                scope.loadMoreResults = function(){
                    //if there's still results on the pageList, just display those
                    scope.showLoadingSpinner = true;

                    if(scope.pageList.length){
                        $timeout(function(){ //just to not instantly show stuff
                            scope.visiblePages.push(scope.pageList.shift());
                            scope.showLoadingSpinner = false;
                        }, 1000);
                        //else if there aren't results on the pageList, but there's a function to get more results, try that route
                    } else if(typeof scope.getMoreResults === "function"){
                        callGetMoreResults().then(
                            function(response){
                                if(response){
                                    $timeout(function(){
                                        scope.visiblePages.push(scope.pageList.shift()); //immediately shift those results over to the visiblePages
                                        scope.showLoadingSpinner = false;
                                        scope.$apply();
                                    });

                                    //TODO - reintegrate lazy load
                                    //callGetMoreResults().then(function(response){});//Once you have one good response, call it again to "pre-load" the next set. This determines if you need to show the button or not.
                                }
                            },
                            function(error){
                                $timeout(function(){
                                    scope.showLoadingSpinner = false;
                                    scope.$apply();
                                });
                            }
                        );

                    }
                };

                //function to determine if the more results button should show
                scope.showMoreResultsButton = function(){
                    var hasPageListLength = scope.pageList && scope.pageList.length,
                        hasGetMoreFunction = attrs.hasOwnProperty('getMoreResults'),
                        retrievedAllResultsFromService = scope.totalResults ?
                            (hasPageListLength*scope.itemsPerPage >= scope.totalResults) : true, //if service only returns portion of all results, check if we've gotten them all. If totalResults is undefined, assume we have them all.
                        visiblePages = scope.visiblePages,
                        visiblePagesLength = visiblePages && visiblePages.length,
                        visiblePagesIndexDefined = visiblePages &&
                            visiblePagesLength && visiblePages[visiblePagesLength-1],
                        atEndOfResults = (visiblePagesIndexDefined &&
                            visiblePagesIndexDefined.atEndOfResults) && retrievedAllResultsFromService,
                        lastResultSetFull = (visiblePagesIndexDefined && visiblePagesIndexDefined.resultList &&
                            visiblePagesIndexDefined.resultList.length === scope.itemsPerPage); //special check for PVD, since their total result count is not necessarily accurate.

                    return (hasPageListLength || (hasGetMoreFunction && !atEndOfResults && lastResultSetFull));
                };

                //used to populate the scroll list
                function populateInfiniteScrollList(){
                    scope.pageList = [];   //holds all pages at first, will slowly be emptied into visiblePages by the shift function
                    scope.visiblePages = [];

                    var list = [],
                        i = 0;

                    for(i; i<scope.resultList.length; i++){
                        list.push(scope.resultList[i]);
                    }

                    if(list.length === 0){
                        scope.pageList.push({pageText: "All results filtered away. Please remove filters to see results again.", pageObj: {}});
                    } else {
                        convertListToPageObjects(list);
                    }

                    scope.visiblePages.push(scope.pageList.shift());

                    if(!scope.resultsDisplayed){
                        displayResults();
                    }
                }

                //takes a list and converts it into pages
                //pages are pushed to scope.pageList for storage
                function convertListToPageObjects(paginationList){
                    var itemsPerPage = parseInt(scope.itemsPerPage),
                        totalResultsLength = scope.totalResults || paginationList.length;
                    if(isNaN(itemsPerPage)){
                        itemsPerPage = 10; //default just to keep the loop from breaking
                    }
                    while(paginationList.length){
                        var resultsMin = (pageCounter*itemsPerPage+1),
                            resultsMax = (pageCounter*itemsPerPage)+itemsPerPage <= totalResultsLength ? (pageCounter*itemsPerPage)+itemsPerPage : totalResultsLength,
                            pageText = (pageCounter === 0) ? "" : "Results " + resultsMin + " to " + resultsMax;
                        var showBanner = (pageCounter && pageCounter === 2);
                        showBanner = showBanner && (sessionData && sessionData.appConfig
                            && sessionData.appConfig.D20_DMS
                            && sessionData.appConfig.D20_DMS.DISABLE_DMS
                            && !sessionData.appConfig.D20_DMS.DISABLE_DMS.booleanValue);
                        //showBanner = showBanner && Boolean(sessionData.loggedIn);

                        var pageObj = {
                            pageText: pageText,     //text to display between pages
                            resultList: paginationList.splice(0, itemsPerPage),         //The results that will be shown on that page
                            eSpot: pageCounter >= 2 ? scope.eSpot : null,      //optional espot
                            atEndOfResults: false,
                            showBanner:showBanner
                        };
                        scope.pageList.push(pageObj); //pushing the page object to the pageList
                        pageCounter++;
                    }
                    scope.pageList[scope.pageList.length - 1].atEndOfResults = true;
                }

                //calls the external function to getMoreResults
                function callGetMoreResults(){
                    var deferred = $q.defer();

                    scope.getMoreResults().then(
                        function(response){ //response should be the list of results we want to paginate
                            if(response.length){
                                convertListToPageObjects(response);
                                deferred.resolve(true);
                            } else {
                                var length = scope.visiblePages.length;
                                scope.visiblePages[length - 1].atEndOfResults = true;
                                deferred.resolve(true);
                            }
                        },
                        function(error){
                            console.error(error);
                            deferred.reject(error);
                        }
                    );

                    return deferred.promise;
                }

                //compiles the HTML and attaches the infinite scroll template
                function displayResults(){
                    transcludeFn(scope, function(clonedContent/*, scope2*/){
                        angular.forEach(clonedContent, function(element,index,array) {
                            if (element.nodeType === 3) { // If node is a text node(nodetype=3), it's white space. remove it
                                array.splice(index, 1);
                            }
                        });
                        scope.resultsDisplayed = true;
                        var html2 =  angular.element(   '<div data-ng-repeat="page in visiblePages track by $index">'+
                                                        '<header data-ng-show="page.pageText"><span>{{page.pageText}}</span></header>'+
                                                        '<article data-ng-if="page.showBanner" data-dms-banner data-from-domain="PVDSEARCH"></article>'+
                                                        '<img data-ng-if="page.eSpot" data-ng-click="eSpotClickAction()" ng-src="{{page.eSpot}}" class="eSpot" data-ng-attr-alt="{{eSpotAlt}}" data-ng-attr-title="{{eSpotAlt}}" />'+
                                                        '<ol>'+
                                                        '<li class="cost-ribbon-top" data-ng-show="resultList.length && showRibbon"><span class="cost-ribbon-top-triangle"></span></li>'+
                                                        '<li class="progressive-scroll-item" data-ng-repeat="result in page.resultList">'+
                                                        '</li>'+
                                                        '<li class="cost-ribbon-bottom" data-ng-show="resultList.length && showRibbon"></li>'+
                                                        '</ol>'+
                                                        '</div>');

                        var ngRepeatLi = angular.element(html2.find('ol').children()[1]);
                        ngRepeatLi.append(clonedContent[0].outerHTML);
                        var linkScopeFn = $compile(html2); //$compile returns a linking function, which can be called to link a scope to the template html
                        var content = linkScopeFn(scope); //calling the link function to attach a scope to the template html
                        element.find('section').prepend(content); //prepending the newly created template instance to the element
                    });
                }
            }
        };
    }]);
};